import {
  HubConnectionBuilder,
  LogLevel,
  HubConnection,
} from '@microsoft/signalr';
import { API_SIGNALR_ROUTE } from 'config/api-consts';

export class SignalRService {
  private rConnection: HubConnection;

  constructor() {
    const profile = localStorage.getItem('profile');
    if (profile) {
      this.rConnection = new HubConnectionBuilder()
        .withUrl(API_SIGNALR_ROUTE)
        .configureLogging(LogLevel.Information)
        .build();
      this.rConnection
        ?.start()
        .then(() => undefined)
        .catch(err => {
          // tslint:disable-next-line:no-console
          console.log('connection error', err.message);
        });
    }
  }

  registerChannel = (channel: string, callback: any) => {
    this.rConnection?.on(channel, data => {
      if (typeof callback === 'function') {
        callback(data);
      }
    });
  };
}

const signalRService = new SignalRService();
export default signalRService;
